// rxjs-extension/reactives/array.ts
import { BehaviorSubject } from "rxjs";
var ArrayBehaviorSubject = class extends BehaviorSubject {
  push(item) {
    const returnVal = this.getValue().push(item);
    this.next(this.getValue());
    return returnVal;
  }
  /**
   * will also concat in place
   *
   * @param items
   */
  concat(items) {
    const returnVal = this.getValue().concat(items);
    this.next(returnVal);
    return returnVal;
  }
  pop() {
    const returnVal = this.getValue().pop();
    this.next(this.getValue());
    return returnVal;
  }
  shift() {
    const returnVal = this.getValue().shift();
    this.next(this.getValue());
    return returnVal;
  }
  unshift(item) {
    const returnVal = this.getValue().unshift(item);
    this.next(this.getValue());
    return returnVal;
  }
  splice(start, deleteCount = 0, ...insertItems) {
    const returnVal = this.getValue().splice(start, deleteCount, ...insertItems);
    this.next(this.getValue());
    return returnVal;
  }
  slice(start, end) {
    const returnVal = this.getValue().slice(start, end);
    this.next(this.getValue());
    return returnVal;
  }
  indexOf(item) {
    return this.getValue().indexOf(item);
  }
  includes(item) {
    return this.getValue().includes(item);
  }
  find(compareFn) {
    return this.getValue().find(compareFn);
  }
  findIndex(compareFn) {
    return this.getValue().findIndex(compareFn);
  }
  reduce(callbackFn, initialValue) {
    return this.getValue().reduce(callbackFn, initialValue);
  }
  get length() {
    return this.getValue().length;
  }
};
export {
  ArrayBehaviorSubject
};
